import React from 'react';
import PropTypes from 'prop-types';

import {
  STRING_FIELD_EDUCATION_CURRENT,
} from '../labels';

import formikPropTypes from './formikPropTypes';

import CheckboxField from '../CheckboxField';

export function CurrentlyInProgress({
  onChange, name, formikProps: {
    handleChange, isSubmitting, values,
  },
}) {
  const handleInputChange = (e) => {
    onChange(e);
    handleChange(e);
  };

  return (
    <CheckboxField
      checked={values[name]}
      disabled={isSubmitting}
      label={STRING_FIELD_EDUCATION_CURRENT}
      name={name}
      onChange={handleInputChange}
    />
  );
}

CurrentlyInProgress.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
};

CurrentlyInProgress.defaultProps = {
  onChange: () => {},
};

export default CurrentlyInProgress;
